export default __webpack_public_path__ + "static/media/woking_garra.6613bfff.png";